export const ORDER_MAP = {
  'descending': 'DESC',
  'ascending': 'ASC'
}
